export const locale = {
  lang: "en",
  data: {
    TITLE: "Closed for scheduled maintenance!",
    SUBTITLE:
      "We're sorry for the inconvenience. <br /> Please check back later or contact your administrator."
  }
};
